const theme = {
    id: 'light',
    bgColor: "#F5F6FA",
    cardColor: "rgb(255,255,255)",
    inputColor: "rgba(238,238,238, 0.8)",
    textColor: "rgb(85, 85, 85)",
}

export default theme;